import { Component, HostListener, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-scroll-nav',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="hasScroll()"
      class="lg:hidden fixed right-3 z-50 flex flex-col gap-2"
      [style.bottom]="'5rem'">

      <button *ngIf="!atTop()"
        (click)="scrollTop()"
        aria-label="Ir al inicio"
        class="w-10 h-10 rounded-full bg-gray-800/50 text-white flex items-center justify-center backdrop-blur-sm hover:bg-gray-800/70 active:scale-95 transition shadow-md">
        <i class="pi pi-chevron-up text-sm"></i>
      </button>

      <button *ngIf="!atBottom()"
        (click)="scrollBottom()"
        aria-label="Ir al final"
        class="w-10 h-10 rounded-full bg-gray-800/50 text-white flex items-center justify-center backdrop-blur-sm hover:bg-gray-800/70 active:scale-95 transition shadow-md">
        <i class="pi pi-chevron-down text-sm"></i>
      </button>

    </div>
  `,
})
export class ScrollNavComponent implements OnInit {
  hasScroll = signal(false);
  atTop = signal(true);
  atBottom = signal(false);

  ngOnInit() {
    this.update();
  }

  @HostListener('window:scroll')
  @HostListener('window:resize')
  update() {
    const scrollTop = window.scrollY;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = window.innerHeight;

    this.hasScroll.set(scrollHeight > clientHeight + 16);
    this.atTop.set(scrollTop < 50);
    this.atBottom.set(scrollTop + clientHeight >= scrollHeight - 50);
  }

  scrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  scrollBottom() {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  }
}
